/**
 * Amenity service - handles all amenity-related API operations
 */

import { BaseApiClient } from '../core/base-client';
import { PaginationConstants } from '../types';

// Amenity response types based on the backend API
export interface CoworkingManagerAmenity {
  id: number;
  propertyId: number;
  name: string;
  description?: string;
  pricingType: string; // "Free" or "Paid"
  unitPrice: number;
  setUpCost: number;
  unPublished: boolean;
  inActive: boolean;
  applyTax: string;
  amenityTax: any[];
}

export interface AmenityListResponse {
  amenities: CoworkingManagerAmenity[];
  totalCount: number;
}

export class AmenityService {
  constructor(private client: BaseApiClient) {}

  /**
   * Get amenities for a specific property
   */
  async getAmenitiesByProperty(
    propertyId: number,
    pageSize: number = PaginationConstants.DEFAULT_PAGE_SIZE,
    pageNo: number = 1,
    includeUnPublished: boolean = false,
    includeInActive: boolean = false
  ): Promise<AmenityListResponse> {
    const params = new URLSearchParams({
      pageSize: pageSize.toString(),
      pageNo: pageNo.toString(),
      propertyId: propertyId.toString(),
      includeUnPublished: includeUnPublished.toString(),
      includeInActive: includeInActive.toString()
    });

    return this.client.get<AmenityListResponse>(`/api/amenities?${params.toString()}`);
  }

  /**
   * Get a single amenity by ID
   */
  async getAmenity(id: number): Promise<CoworkingManagerAmenity> {
    return this.client.get<CoworkingManagerAmenity>(`/api/amenities/${id}`);
  }
}

/**
 * Factory function to create amenity service
 */
export function createAmenityService(client: BaseApiClient): AmenityService {
  return new AmenityService(client);
} 